import sanitizeHtml from 'sanitize-html';

export const sanitizeOptions = {
	allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'iframe']),
	allowedAttributes: {
		a: ['href', 'name', 'target'],
		img: ['alt', 'height', 'loading', 'src', 'srcset', 'title', 'width'],
		iframe: ['allow', 'allowfullscreen', 'frameborder', 'height', 'src', 'title', 'width'],
		'*': ['style'],
	},
};
